/*
 * @Author: M.D.
 * @Date: 2019-12-10 22:05:23
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
import store from 'store'
import {
  USR_TOKEN
} from '@/util/const'
import API from '@/api/api'

const user = {
  state: {
    userInfo: {},
    memberInfo: {},
    unreadNum: 0
  },
  mutations: {
    'SET_USER_INFO': (state, val) => {
      state.userInfo = val
    },
    'SET_MEMBER_INFO': (state, val) => {
      state.memberInfo = val
    },
    'SET_UNREAD_NUM': (state, val) => {
      state.unreadNum = val
    }
  },
  actions: {
    loginSucc: ({
      commit,
      dispatch
    }, val) => {
      return new Promise((resolve, reject) => {
        if (val.data.result.token) {
          store.set(USR_TOKEN, val.data.result.token)
          commit('SET_USER_INFO', val.data.result)
          commit('SET_CUR_LOC', [val.data.result.provinceCode, val.data.result.cityCode])
          // dispatch('setCurLoc', [val.data.result.provinceCode, val.data.result.cityCode])
          dispatch('getMemberInfo').then(res => {
            dispatch('getUnreadCount').then(res => {
              resolve(res)
            }).catch(error => {
              reject(error)
            })
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    getUnreadCount: ({
      commit
    }) => {
      return new Promise((resolve, reject) => {
        API.getMsgCount()
          .then(res => {
            if (res.data.statusCode === '200') {
              commit('SET_UNREAD_NUM', Number(res.data.result || 0))
              resolve(res)
            } else {
              throw new Error(res.data.message)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    userLogOut: ({
      commit,
      dispatch
    }, vm) => {
      vm.$lstore.remove(USR_TOKEN)
      dispatch('setUserInfo', {})
      vm.$emit('openLoginDialog')
      // vm.$router.replace({
      //   name: 'index'
      // })
    },
    setUserInfo: ({
      commit,
      dispatch
    }, val) => {
      return new Promise((resolve, reject) => {
        if (val.token) {

          store.set(USR_TOKEN, val.token)
          dispatch('getMemberInfo')
        } else {
          commit('SET_MEMBER_INFO', {})
        }
        commit('SET_USER_INFO', val)
      })
    },
    getMemberInfo: ({
      commit,
      rootGetters
    }) => {
      return new Promise((resolve, reject) => {
        API.getMemberInfo()
          .then(res => {
            if (res.data && res.data.statusCode === '200') {
              commit('SET_MEMBER_INFO', res.data.result)
              resolve(res)
            } else {
              throw new Error(res.data.message)
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
}

export default user
